// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportTypography_ReportTypography__TKmCT .ReportTypography_TitleBox__NTMYM h3 {
  color: var(--secondaryColor);
  font-size: 20px !important;
  margin-bottom: 10px;
  text-transform: uppercase;
}
.ReportTypography_ReportTypography__TKmCT .ReportTypography_TitleBox__NTMYM h4 {
  color: var(--mainColor);
  font-size: 16px !important;
  font-weight: bold !important;
  text-transform: uppercase;
}
.ReportTypography_ReportTypography__TKmCT .ReportTypography_paragraph__IIWYP ul {
  -webkit-padding-start: 30px;
          padding-inline-start: 30px;
}
.ReportTypography_ReportTypography__TKmCT .ReportTypography_paragraph__IIWYP ol {
  -webkit-padding-start: 25px;
          padding-inline-start: 25px;
}`, "",{"version":3,"sources":["webpack://./src/reports/components/ReportTypography/ReportTypography.module.scss"],"names":[],"mappings":"AAEI;EACE,4BAAA;EACA,0BAAA;EACA,mBAAA;EACA,yBAAA;AADN;AAGI;EACE,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;AADN;AAKI;EACE,2BAAA;UAAA,0BAAA;AAHN;AAKI;EACE,2BAAA;UAAA,0BAAA;AAHN","sourcesContent":[".ReportTypography {\n  .TitleBox {\n    h3 {\n      color: var(--secondaryColor);\n      font-size: 20px !important;\n      margin-bottom: 10px;\n      text-transform: uppercase;\n    }\n    h4 {\n      color: var(--mainColor);\n      font-size: 16px !important;\n      font-weight: bold !important;\n      text-transform: uppercase;\n    }\n  }\n  .paragraph {\n    ul {\n      padding-inline-start: 30px;\n    }\n    ol {\n      padding-inline-start: 25px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ReportTypography": `ReportTypography_ReportTypography__TKmCT`,
	"TitleBox": `ReportTypography_TitleBox__NTMYM`,
	"paragraph": `ReportTypography_paragraph__IIWYP`
};
export default ___CSS_LOADER_EXPORT___;
